import { CompatClient, Stomp } from '@stomp/stompjs';
import { useContext, useEffect, useState } from 'react';
import SockJS from 'sockjs-client';
import { DataViewProps } from '../view/common/DataView';
import { Auth } from './Auth';

export const useWebSocketListener = function <T>(
    props: DataViewProps<T> & {
        server?: string, // http://localhost:8080
        endPoint: string, // /agent/websocket
        topic?: string, // /topic/taskExec
    }
) {

    const { accessToken } = useContext(Auth);
    const { server, endPoint, topic } = props;
    const setData = props['setData'];

    // Connect to the WebSocket when the component is mounted
    useEffect(() => {

        if (!topic || !accessToken) return;

        // remove end / and start / from server, endPoint and topic
        const s = (server || window.location.origin).replace(/\/$/, '');
        const e = endPoint.replace(/^\//, '');
        const t = topic.replace(/^\//, '');

        // Create a new WebSocket client
        const client = Stomp.over(()=> new SockJS(`${s}/${e}?access_token=${accessToken}`));
        client.connect({}, () => {
            console.log(`Suscribed to ${s}/${e}/${t}`);
            client.subscribe(`/${t}`, (message) => {
                console.log(`Received message from ${s}/${e}/${t}:`, message.body);
                const data = JSON.parse(message.body) as T;
                setData(data as T);
            });
        });

        // Save the client in the state
        //setStompClient(client);

        // Disconnect the client when the component is unmounted
        return () => {
            //console.log(`Unsuscribed from ${s}/${e}/${t}`);
            console.log(`Unsuscribed`);
            if (client) client.disconnect();
        };

    }, [ server, endPoint, topic, accessToken ]);

};

export const useStatefulWebSocketListener = function <T>(
    props: DataViewProps<T> & {
        server?: string, // http://localhost:8080
        endPoint: string, // /agent/websocket
        topic?: string, // /topic/taskExec
    }
) {

    const [ data, setData ] = useState<T | undefined>(props.data);

    useWebSocketListener({ ...props, data, setData:(data: T | undefined)=>{
        setData(data);
        props.setData(data);
    }});

    return { data, setData };
};

